import React from 'react';
import classNames from 'classnames';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBodyText,
  FDBox,
  FDIcon,
  FDPaper,
  FDStack,
  FDTitleText,
} from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { isFieldVisible } from 'Components/UI/Meta/isFieldVisible';
import { dataAttrs } from 'Helpers/Testing';

const useStyles = buildUseStyles('RoadmapActionsThisMonthStepContent', (theme) => ({
  lineItemBorderTop: {
    '&:not(:first-child)': { // this sets the border-top for all but the first item, because we're in an outlined paper
      borderTop: `1px solid ${theme.palette.divider}`,
    },
  },
}));

export const Content = () => {
  const { resource } = useMetaLayoutContext();
  useBoneBackgroundColor();
  const classes = useStyles();

  const actions = resource?.attr('actionsThisMonth')?.resources?.()?.list?.() ?? [];
  const hasActions = actions.length > 0;

  return (
    <FDStack direction={'column'} spacing={4} alignItems={'center'}>
      <FDPaper appearance={'flat'} padding={2} width={1} rounded>
        {hasActions ? (
          <FDStack direction={'column'} spacing={2} paddingX={1}>
            <FDBox paddingY={2}>
              <MetaControlField attr={'actionsTitle'} />
            </FDBox>
            <FDPaper appearance={'outlined'} width={1} rounded>
              {actions.map((action) => (
                <div className={classNames(classes.lineItemBorderTop)} key={action.id()} {...dataAttrs('roadmap-this-month-action')}>
                  <FDStack direction={'row'} spacing={1} padding={1}>
                    <FDBox paddingY={0.5} paddingX={0}>
                      <FDIcon icon={action.attr('icon')} />
                    </FDBox>
                    <FDStack direction={'column'} spacing={0.5}>
                      <FDTitleText value={action.attr('title')} />
                      <FDBodyText value={action.attr('subtitle')} size={'sm'} />
                    </FDStack>
                  </FDStack>
                </div>
              ))}
            </FDPaper>
            <MetaControlField attr={'actionsDisclaimer'} />
          </FDStack>
        ) : <FDBodyText value={'No actions this month.'} />}
      </FDPaper>
      {(isFieldVisible(resource, resource.metaField('nextStepsTitle')) || isFieldVisible(resource, resource.metaField('nextStepsSubtitle'))) && (
        <FDPaper appearance={'flat'} padding={2} width={1} rounded>
          <FDStack direction={'column'} spacing={2}>
            <MetaControlField attr={'nextStepsTitle'} />
            <MetaControlField attr={'nextStepsSubtitle'} />
          </FDStack>
        </FDPaper>
      )}
    </FDStack>
  );
};
